"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * An abstract keyword entry handler.
 */

var EntryHandlerKeyword =
/*#__PURE__*/
function () {
  function EntryHandlerKeyword(keyword) {
    _classCallCheck(this, EntryHandlerKeyword);

    this.keyword = keyword;
  }

  _createClass(EntryHandlerKeyword, [{
    key: "isPropertyHandler",
    value: function isPropertyHandler() {
      return false;
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, keys, depth, inProperty) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", false);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function validate(_x, _x2, _x3, _x4, _x5) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(parsingContext, util, key, keys, depth) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", key === this.keyword);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function test(_x6, _x7, _x8, _x9, _x10) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }]);

  return EntryHandlerKeyword;
}();

exports.EntryHandlerKeyword = EntryHandlerKeyword;